import React from 'react'
import Button from '../../components/Button/Button';
import CompletedImage from '../../assets/img/completed.svg';
import { handleLoading } from '../../utils/handleLoading';

export const bidsColumns = (isAdmin) => {
  let columns = [
    {
      title: "Bid",
      dataIndex: "bid",
      key: "bid",
    },
    {
      title: "Scope",
      dataIndex: "scope",
      key: "scope",
    },
    {
      title: "Prize",
      dataIndex: "prize",
      key: "prize",
    },
    {
      title: "Max Prize",
      dataIndex: "maxPrize",
      key: "maxPrize",
    },
    {
      title: "created",
      dataIndex: "created",
      key: "created",
    },
    // {
    //   title: "",
    //   dataIndex: "set_won",
    //   key: "set_won",
    //   render: ({ handleSetWon, won, prize, loading, buttonId, isExternal }, data) => !won ? (!isExternal && prize) && <Button
    //     title="Set Won"
    //     type="button"
    //     size="xl"
    //     theme="blue"
    //     className="radius-8"
    //     style={{ fontSize: 18 }}
    //     onClick={() => handleSetWon(data.id)}
    //     loading={(+buttonId === +data.id) && handleLoading(loading, "SetWon")}
    //   /> : !isExternal && <div className='align-middle'> <img className='success-icon align-middle' src={CompletedImage} alt='success-icon' /> </div>
    // },
  ];

  if(isAdmin) {
    columns = [
      {
        title: "name",
        dataIndex: "first_name",
        key: "first_name",
      },
      {
        title: "surname",
        dataIndex: "last_name",
        key: "last_name",
      },
      {
        title: "Mail",
        dataIndex: "email",
        key: "email",
      },
      ...columns,
      {
        title: "",
        dataIndex: "move_bid",
        key: "move_bid",
        render: ({ handleMoveBid, bidMoved, offerClosed }, data) => offerClosed ?
          !bidMoved ? <Button
            title="Move Bid"
            type="button"
            size="xl"
            theme="blue"
            className="radius-8"
            style={{ fontSize: 18 }}
            onClick={(e) => {
              e.stopPropagation();
              handleMoveBid(data.id, data.id)
            }}
          /> : <div className='flex-container align-center align-middle'>
                  <img width={28} height={28} src={CompletedImage} alt='success-icon' />
                  <div style={{marginLeft: "8px"}}>Moved</div>
                </div>
        : null
      },
    ]
  }

  return columns;
}
